import { render, staticRenderFns } from "./SliderField.vue?vue&type=template&id=2352dd62&"
import script from "./SliderField.vue?vue&type=script&lang=js&"
export * from "./SliderField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports